import { ModuleConfig } from '@schamburg-web/interfaces';
import { Box, Typography } from '@mui/material';
import DelayIcon from '../../components/DelayIcon/DelayIcon';

const TravelTimesMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
  iconSize?: number;
  fontSize?: number;
}> = ({ icon, module, iconSize = 40, fontSize = 20 }) => {
  //const angle = icon.angle ?? 0; // Default to 0 if no heading present
  const directionToAngle = (dir: string | undefined): number => {
    switch (dir?.toUpperCase()) {
      case 'N':
        return 270;
      case 'E':
        return 0;
      case 'S':
        return 90;
      case 'W':
        return 180;
      default:
        return 0; // fallback if direction is missing or invalid
    }
  };

  const angle = directionToAngle(icon.dir);
  const travelTime = icon.traveltime ?? '--'; // fallback if missing
  // Adjust vertical position based on arrow direction to avoid overlap
  const topPosition = angle === 0 ? '55%' : '50%'; // 0 = East (arrow points up after rotation)
  return (
    <Box
      sx={{
        position: 'relative',
        width: iconSize,
        height: iconSize,
      }}
    >
      {/* DelayIcon with rotation */}
      <DelayIcon angle={angle} size={iconSize} />

      {/* Overlayed TT value */}
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          top: topPosition,
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: '#47a',
          fontWeight: 'bold',
          pointerEvents: 'none',
          fontSize: fontSize,
        }}
      >
        {travelTime}
      </Typography>
    </Box>
  );
};

export const TravelTimesMapMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  return (
    <TravelTimesMarker
      icon={icon}
      module={module}
      iconSize={30}
      fontSize={14}
    />
  );
};

export const TravelTimesAvatar: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  return (
    <TravelTimesMarker
      icon={icon}
      module={module}
      iconSize={40}
      fontSize={20}
    />
  );
};

export default TravelTimesMarker;
